import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { AgreementApiPort } from './ports/agreement-api.port';
import { AdessoContractAgreementApiAdapter } from './adapters/adesso-contract-agreement-api.adapter';

/**
 * Provides AgreementApiPort backed by the adesso-connector-api adapter.
 */
export function provideContractAgreementApi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: AgreementApiPort, useClass: AdessoContractAgreementApiAdapter }
  ]);
}
